import React from 'react'
import { connect } from 'react-redux'
import { withRouter } from 'react-router-dom'
import PropTypes from 'prop-types'
import { Button, Modal, ModalHeader, ModalBody, ModalFooter } from 'reactstrap'
import ReactLoading from 'react-loading'
import { deleteBlock, closeDeleteBlockModal } from 'redux/actions/blocks'

const DeleteModal = ({ isOpen, closeModal, block, deleteBlock, isLoading, source, history }) => !block ? null : (
  <Modal isOpen={isOpen} fade={false} toggle={closeModal} className="warning">
    <ModalHeader toggle={closeModal}>Eliminar Manzana</ModalHeader>
    <ModalBody>
      Estás seguro de que quieres borrar la manzana {block.name} ?
    </ModalBody>
    <ModalFooter>
      <Button disabled={isLoading} color="warning" className="mr-1" onClick={() => deleteBlock({block, source, history})}>
        {isLoading && <ReactLoading type="spinningBubbles" color="#fff" height={10} width={10} className="d-inline-block mr-4 ml-2" />}
        Eliminar
      </Button>
      <Button disabled={isLoading} color="primary" onClick={closeModal}>Cancelar</Button>
    </ModalFooter>
  </Modal>
)

DeleteModal.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  isLoading: PropTypes.bool,
  block: PropTypes.shape({
    name: PropTypes.string.isRequired
  }),
  history: PropTypes.shape({
    push: PropTypes.func.isRequired
  }).isRequired,
  source: PropTypes.string,
  closeModal: PropTypes.func.isRequired,
  deleteBlock: PropTypes.func.isRequired,
}

const mapStateToProps = ({ blocks: { source, openedDeleteBlockModal, selectedBlock, deletingBlock }}) => {
  return ({
    source,
    isOpen: openedDeleteBlockModal,
    block: selectedBlock,
    isLoading: deletingBlock
  })
}

const mapDispatchToProps = dispatch => ({
  deleteBlock: info => dispatch(deleteBlock(info)),
  closeModal: () => dispatch(closeDeleteBlockModal()),
})

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(DeleteModal))
